import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/sign/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/sign/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/sign/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/sign/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/sign/delete',
        method: 'post',
        data
    })
}

export function active(signIds) {
    let url = '/sign/active'
    let data = {signIds:signIds}
    console.log(data)
    // data.json = true
    // console.log(data)
    return request.post(url,data)
}
